import { styled } from '@mui/system';
import { Divider, Paper } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme, sx }) => ({
    ...sx,
    zIndex: 10,
    padding: theme.spacing(1),
    border: '1px solid',
    borderColor: theme.palette.divider
}));

export const ButtonContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 8
});

export const StyledHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
    marginLeft: '-8px',
    marginRight: '-8px'
}));